// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1zUvp","index":"styles_index__1gJIl"};